"use client";

import { useEffect } from "react";
import { motion } from "framer-motion";

import { analytics } from "@/lib/analytics/analytics";
import { AnalyticsEvents } from "@/lib/analytics/events";

import { MarketingPageShell } from "@/components/marketing/MarketingPageShell";
import type { ResolvedPublicPricing } from "@/lib/pricing/types";

import { MarketingPricingPlans } from "./MarketingPricingPlans";

type PublicPricingPageProps = {
  pricing: ResolvedPublicPricing;
};

export function PublicPricingPage({ pricing }: PublicPricingPageProps) {
  useEffect(() => {
    analytics.captureOnce("page:pricing", AnalyticsEvents.pricingPageView, {
      region: pricing.region,
      currency: pricing.currency,
    });
  }, [pricing.currency, pricing.region]);

  return (
    <MarketingPageShell contentClassName="pb-32">
      <div className="mx-auto max-w-6xl px-6 lg:px-8">
        <motion.header
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.55 }}
          className="mb-20 pt-4 text-center sm:pt-8"
        >
          <p className="mb-4 text-[11px] font-medium uppercase tracking-[0.22em] text-neutral-500">
            Pricing
          </p>
          <h1 className="text-[clamp(2rem,5vw,3.25rem)] font-semibold tracking-[-0.03em] text-white">
            Start free. Upgrade when it&apos;s yours.
          </h1>
          <p className="mx-auto mt-5 max-w-lg text-[16px] leading-relaxed text-neutral-400">
            Build and publish interactive notebooks with generous limits from the start. Pro opens more workspace and live links when you need more.
          </p>
        </motion.header>

        <motion.div
          initial={{ opacity: 0, y: 24 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6, delay: 0.06 }}
        >
          <MarketingPricingPlans pricing={pricing} />
        </motion.div>
      </div>
    </MarketingPageShell>
  );
}
